export default "__VITE_ASSET__DtYtJQ0k__"